// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'user' implicitly has an 'any' type.
const setColor = (user, key) => {
  return user.highlights.includes(key) ? "rgba(0, 0, 0, 0.85)" : "rgb(197, 199, 199)";
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'user' implicitly has an 'any' type.
export function SearchAttribute(user, key) {
  return user[key] ? (
    <div key={`${user._id}-${key}`} style={{ color: setColor(user, key) }}>
      {user[key]}
    </div>
  ) : (
    <></>
  );
}
